import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SolutionSpotlight from '@/pages/solutions/components/SolutionSpotlight';
import SolutionEntries from '@/pages/solutions/components/SolutionEntries';

export default function Solutions() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="解决方案｜ePin食安码与数字商业方案｜华辉数智"
        description="华辉数智按客户业务目标组合产品、技术与实施能力，提供可落地的整体解决方案，重点专题包括 ePin食安码一物一码全链路食安溯源与农产品数字化上行。"
        keywords="解决方案,ePin食安码,食品安全溯源,一物一码,数字商业,乡村数字经济,农产品溯源"
        path="/solutions"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: '解决方案',
          description: '按客户业务目标组合产品、技术与实施能力，提供可落地的整体解决方案。',
          hasPart: {
            '@type': 'WebPage',
            name: 'ePin食安码：一物一码全链路食安溯源',
            url: 'https://www.huahui-digital.com/cases/epin-food-safety',
          },
        }}
      />

      <div className="pt-20 md:pt-24">
        <Breadcrumb items={[{ label: '解决方案' }]} />
      </div>

      <main>
        <SolutionSpotlight />
        <SolutionEntries />
      </main>

      <Footer />
    </div>
  );
}